import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {ContactMethodStatuses} from '../../../contact-method-statuses/contact-method-statuses';
import {ContactIcon} from '../../../icon/svg/contact-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from '../../../icon/svg/external-link-icon';

import styles from './person-card-content.module.css';

type Props = {
    id: string;
    name: string;
    location: string | null | undefined;
    jobTitle: string | null | undefined;
    position: string | null | undefined;
    // added contact only
    email?: string | null | undefined;
    phone?: string | null | undefined;
    // addable person only
    hasEmail?: boolean;
    hasPhone?: boolean;
    hasLinkedinUrl?: boolean;
    isSelected?: boolean;
    onClickName?: (arg1: string) => any | null | undefined;
};

export function PersonCardContent(props: Props) {
    const isContact =
        typeof props.hasEmail === 'undefined' && typeof props.hasPhone === 'undefined';

    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    });

    return (
        <div className={styles['person-card-content']}>
            {isContact ? (
                <ContactIcon size={15} wrapWithDiv={false} />
            ) : (
                <input type='checkbox' checked={props.isSelected} readOnly={true} />
            )}
            <div className={styles.details}>
                {props.onClickName ? (
                    <div className={styles['name-button-container']}>
                        {/* @ts-expect-error */}
                        <div onClick={() => props.onClickName(props.id)}>{props.name}</div>
                    </div>
                ) : (
                    <div>{props.name}</div>
                )}
                {isContact && props.email && <div>{props.email}</div>}
                {isContact && props.phone && <div>{props.phone}</div>}
                {props.jobTitle && <div>{props.jobTitle}</div>}
                {props.position && <div>{props.position}</div>}
                {props.location && <div>{props.location}</div>}
            </div>
            <div>
                {isContact ? (
                    <ExternalLinkIcon size={13} wrapWithDiv={false} />
                ) : (
                    <ContactMethodStatuses
                        hasEmail={props.hasEmail}
                        hasLinkedinUrl={props.hasLinkedinUrl}
                        hasPhone={props.hasPhone}
                    />
                )}
            </div>
        </div>
    );
}
